





































import {
  Mixins,
  Component,
  Prop,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ManageMixin from '@/mixins/Manage.vue';
import RoundModule from '@/store/modules/Round';

@Component({
  components: {
  },
})
export default class RoundView extends Mixins(
  ManageMixin,
) {
  @Prop() readonly data!: any;

  @Prop() readonly componentKey!: any;

  @Prop() readonly paginationDetail!: any;

  @Prop() readonly handleModalDetail!: Function;

  @Prop() readonly openModalTracking!: Function;

  @Prop() readonly selectRound!: Function;

  RoundInstance = getModule(RoundModule, this.$store);

  openModalDetail(items) {
    this.handleModalDetail(items);
  }

  handleopenModalTracking(items) {
    this.openModalTracking(items);
  }

  async handlePrepareData(modalData, items, event) {
    this.selectRound(modalData, items, event);
  }
}
